export default class VendorTeamName {
  private readonly _value: string;

  constructor(value: string) {
    this._value = value;
  }

  public isEqualTo(other: VendorTeamName): boolean {
    return this.value === other?.value;
  }

  public get value(): string {
    return this._value;
  }

  public static get Prototype(): VendorTeamName {
    return new VendorTeamName("");
  }

  public fromJSON(value: string): VendorTeamName {
    return new VendorTeamName(value);
  }
  public toJSON(): string {
    return this.value;
  }
  public clone(): VendorTeamName {
    return new VendorTeamName(this.value);
  }
}
